export var FormFields;
(function (FormFields) {
    FormFields["status"] = "status";
    FormFields["startDate"] = "startDate";
    FormFields["setEndDate"] = "setEndDate";
    FormFields["endDate"] = "endDate";
})(FormFields || (FormFields = {}));
